module.exports = __webpack_public_path__ + "img/wellness.d3955f4b.jpg";